import { useEffect, useState } from "react";
import { useBlockUI } from "../../../shared/services/block-ui-service";
import { PerformanceHistoryFilter } from "../../../filters/performance-history-filter";
import { BaseResponse } from "../../../models/base-response";
import instance from "../../index";
import ClientMonthPerformance from "../../../models/client-month-performance";
import { DriverPerformanceHistoryDto } from "../../../models/driver-performance-history";
import { DriverMonthPerformance } from "../../../models/driver-month-performance";

export const usePerformanceHistoryService = () => {

    const [loading, setLoading] = useState<boolean>(false);
    const blockUI = useBlockUI();

    useEffect(() => {
        blockUI?.setActive(loading)
    }, [loading]);

    async function getClientMonthPerformanceHistory(clientId: string,filter?: PerformanceHistoryFilter): Promise<BaseResponse<ClientMonthPerformance>> {
        setLoading(true)
        const response = await instance.get<BaseResponse<ClientMonthPerformance>>(`/v1/backoffice/performance-history/client/${clientId}/month/report`, {
            params: filter
        }).finally(() => setLoading(false));
        return response.data;
    }

    async function getDriverPerformanceHistory(filter?: PerformanceHistoryFilter): Promise<BaseResponse<ClientMonthPerformance>> {
        setLoading(true)
        const response = await instance.get<BaseResponse<ClientMonthPerformance>>('/v1/backoffice/performance-history/driver-month/report', {
            params: filter
        }).finally(() => setLoading(false));
        return response.data;
    }

    async function getAllDriverPerformanceHistory(filter?: PerformanceHistoryFilter): Promise<BaseResponse<ClientMonthPerformance>> {
        setLoading(true)
        const response = await instance.get<BaseResponse<ClientMonthPerformance>>('/v1/backoffice/performance-history/all/report', {
            params: filter
        }).finally(() => setLoading(false));
        return response.data;
    }

    async function getDriverPerformanceByCpf(cpf: string, filter?: PerformanceHistoryFilter): Promise<BaseResponse<ClientMonthPerformance>> {
        setLoading(true)
        const response = await instance.get<BaseResponse<ClientMonthPerformance>>(`/v1/backoffice/performance-history/cpf/${cpf}/report`, {
            params: filter
        }).finally(() => setLoading(false));
        return response.data;
    }

    async function getToExcelClientMonthPerformanceHistory(clientId: string,filter?: PerformanceHistoryFilter): Promise<any> {
        setLoading(true)
        const response = await instance.get(`/v1/backoffice/performance-history/client/${clientId}/month/report/excel`, {
            params: filter,
            responseType: 'blob',

        }).finally(() => setLoading(false));
        return response.data;
    }

    async function getDriverDailyPerformance(cpf: string, intervalStart: string, intervalEnd: string): Promise<DriverPerformanceHistoryDto[]> {
        const response = await instance.get<BaseResponse<DriverPerformanceHistoryDto[]>>(`/v1/backoffice/performance-history/cpf/${cpf}/report`, {
            params: {
                InicioIntervalo: intervalStart,
                FimIntervalo: intervalEnd
            }
        });
        return response.data.data || [];
    }

    async function getDriverMonthPerformance(cpf: string, year: number, month: number): Promise<DriverMonthPerformance | null> {
        const response = await instance.get<BaseResponse<DriverMonthPerformance>>(`/v1/backoffice/performance-history/cpf/${cpf}/month/report`, {
            params: {
                Year: year,
                Month: month
            }
        });
        // A resposta vem como {data: {...}, success: true}
        // response.data já é o objeto BaseResponse, então response.data.data é o DriverMonthPerformance
        const result = response.data?.data || null;
        return result;
    }

    return {
        loading,
        getClientMonthPerformanceHistory,
        getDriverPerformanceHistory,
        getAllDriverPerformanceHistory,
        getDriverPerformanceByCpf,
        getToExcelClientMonthPerformanceHistory,
        getDriverDailyPerformance,
        getDriverMonthPerformance
    };
}
